import React from 'react';

const HeaderImageSection = (props) => {
	return <div id={props.id} />;
};

export default HeaderImageSection;
